// 나만 보이는 글(앱의 `chat.postEphemeral`). 서버는 저장하지 않으므로 이 판도
// **화면이 켜져 있는 동안만** 있다 — 새로 고치면 사라지는 것이 규약이다.
//
// 타임라인 줄과 섞지 않는다. 번호(seq)가 없는 글을 줄 사이에 끼우면 안 읽음 띠·
// 갭 복구가 그 자리를 셈에 넣을지 헷갈린다. 입력칸 바로 위에 따로 쌓는다.

import type { Body, UserId } from '@maru/protocol'
import { BodyView, type EmojiLook, type GroupLook } from './body_view.tsx'
import { useT } from './i18n.ts'
import { Button } from './kit/button.tsx'

export interface WhisperItem {
  /** 화면 안에서만 쓰는 번호. 받은 순서다. */
  key: number
  author: UserId
  body: Body
}

export interface WhispersProps {
  items: readonly WhisperItem[]
  name_of(user: UserId): string | undefined
  me: UserId
  group_of?: GroupLook | undefined
  emoji_of?: EmojiLook | undefined
  dismiss(key: number): void
}

export function Whispers({ items, name_of, me, group_of, emoji_of, dismiss }: WhispersProps) {
  const t = useT()
  if (items.length === 0) return null
  return (
    <section className="Whispers" aria-label={t('나만 볼 수 있는 메시지')}>
      {items.map((w) => (
        <article key={w.key} className="whisper">
          <header>
            <b>{name_of(w.author) ?? `#${w.author}`}</b>
            <span className="only-me">{t('나만 볼 수 있어요')}</span>
            <Button variant="ghost" size="sm" className="hide" onClick={() => dismiss(w.key)}>
              {t('닫기')}
            </Button>
          </header>
          <BodyView
            body={w.body}
            name_of={name_of}
            me={me}
            group_of={group_of}
            emoji_of={emoji_of}
          />
        </article>
      ))}
    </section>
  )
}
